export default __webpack_public_path__ + "static/media/SG-LightBlue-0003.f24a4057.png";